/**
 * Created by Nicholas Azar on 11/20/2016.
 */

import {NgModule} from '@angular/core';
import {Ng2SelectizeComponent} from "./ng2-selectize.component";


export class Ng2SelectizeModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [Ng2SelectizeComponent],
  exports: [Ng2SelectizeComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
